import { IConfig } from '@cian/config/shared';
import { createSelector } from '@reduxjs/toolkit';
import { selectOnlineBooking } from 'shared/selectors/jsonQuery';

export const selectOnlineBookingFilter = (config: IConfig) => {
  return createSelector([selectOnlineBooking], value => ({
    label: 'Формат бронирования',
    value: Boolean(value),
    visible: Boolean(config.get<boolean>('dailyrent.onlineBookingFilterDesktop.Enabled')),
  }));
};
